import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ArticleComment from './article.comment.component';
import Icon from 'component/shared/icon/icon.counter.component';
import IconComponent from 'style/fonts/glyphmaps/icon.component';
import userImage from 'resource/img/user-default.png';
import CommentOptionModal from 'component/modals/comment.options.component';

class ArticleCommentSection extends PureComponent {
  constructor() {
    super();
    this.state = {
      open: false,
      commentId: null,
    };
  }

  _toggleOptionModal = (id, open = true) => {
    this.setState({
      open,
      commentId: id,
    });
  };

  render() {
    const {
      article: { id },
      comments,
      addArticleEvent,
      user,
    } = this.props;

    return (
      <>
        <div
          className="flex-column"
          style={{
            width: '70%',
            margin: '0 auto',
            backgroundColor: '#EEE',
            padding: 10,
          }}
        >
          <span style={{ fontSize: 25, fontWeight: 'bold' }}>
            {comments.length} Comentários
          </span>
          <ArticleComment id={id} />
          {comments.map(
            ({
              comment,
              id,
              article_id,
              like_count,
              dislike_count,
              id_user,
            }) => {
              return (
                <div
                  key={id.toString()}
                  className="flex-row justify-between align-center"
                  style={{ padding: 15, marginTop: 20 }}
                >
                  <div className=" flex-column self-align-stretch">
                    <div className="flex-column">
                      <div className="flex-row align-center">
                        <img
                          src={
                            id_user && id_user.image ? id_user.image : userImage
                          }
                          alt="User"
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: 40,
                            margin: 15,
                            marginLeft: 0,
                          }}
                        />
                        <span>
                          <strong>
                            {id_user && id_user.name ? id_user.name : ''}
                          </strong>
                        </span>
                      </div>
                    </div>
                    <div>
                      <p>{comment}</p>
                    </div>
                    <span className="flex-row">
                      <Icon
                        fontFamily="AntDesign"
                        name="like1"
                        color="#AAA"
                        size={23}
                        className="article-icon"
                        clickCount={like_count}
                        onClick={() => addArticleEvent(id, 'LIKE')}
                        containerStyle={{ margin: '20px 10px 0 0' }}
                      />
                      <Icon
                        fontFamily="AntDesign"
                        name="dislike1"
                        color="#AAA"
                        size={23}
                        clickCount={dislike_count}
                        className="article-icon"
                        onClick={() => addArticleEvent(id, 'DISLIKE')}
                        containerStyle={{ margin: '20px 10px 0 0' }}
                      />
                    </span>
                  </div>

                  {user !== null && id_user.id === this.props.user.id && (
                    <div className="flex-row">
                      <IconComponent
                        fontFamily="FontAwesome"
                        name="ellipsis-v"
                        className="article-icon"
                        color="gray"
                        size={20}
                        onClick={() => this._toggleOptionModal(id)}
                      />
                    </div>
                  )}
                </div>
              );
            }
          )}
        </div>
        <CommentOptionModal
          open={this.state.open}
          close={() => this._toggleOptionModal(this.state.commentId, false)}
          id={this.state.commentId}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(
  mapStateToProps,
  null
)(ArticleCommentSection);
